/* eslint-disable react/prop-types */
import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useFormPageHandler, useMergeState } from 'irmlib/hooks'
// import { FlexByRow, XDivider, YDivider, HalfScreen, FlexGrowOne } from 'irmlib/styles'
import isEqual from 'lodash.isequal'
import { Info } from 'irmlib/icons'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
import * as regx from 'irmlib/components/FormControls/'
import { today, afterThirtyDaysFromToday } from 'irmlib/common'
import TemplateFormat from '../Template/TemplateFormation.jsx'
import { TextField, DateTime, CancelButton, SaveButton, Autocomplete, CheckBox } from 'irmlib/components/FormControls'
import { ContainedButton } from 'irmlib/components/Controls/Button'
import { setBusy, clearBusy, openGeneralDialog, closeGeneralDialog } from 'irmlib/containers'
import { ThemeButton, Label, OutlinedButton, ToolTip } from 'irmlib/components/Controls'
import { useHistory, useLocation } from 'react-router-dom'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import * as routePaths from '../../../navigation/routePaths'
import * as constants from 'irmlib/common/constants'
import moment from 'moment'
import { translate } from '../../../irmlib/src/multilanguage'
import { validateAndGetAccountLevel1, validateAndGetAccountLevel2, validateAndGetAccountLevel3 } from '../../../services/skpApi'
import { getUser } from '../../../redux/global'
import { gdeWorkerRole, updateWorkerRoleDistrict } from '../../../services/firestore/login'
import { TextareaAutosize, Dialog, DialogActions, DialogTitle, DialogContent, Grid, Box, Typography } from '@material-ui/core'
import { isDataEntryUser, isSupervisor, successToast } from '../../../common/functions'
import { isEmpty, reject } from 'lodash'
import { totalNoOfBoxesForJob, originalBarcodeLogic, newBarcodeLogic } from '../../../services/common/appConstants'
import { defaultDateFormat2, countryConfig, userRoleAdmin, userRoleSupervisor, userRoleSuperUser } from '../../../common/constants'
import { useTranslation } from 'react-i18next'
import { XDivider, YDivider, CreateTemplateAccountsIntentContainer, CreateJobCheckBoxIntentContainer, CreateJobDatesIntentContainer, CreateJobIntentContainer } from '../../../irmlib/src/styles/index.js'
import { Card, CardContent } from '@mui/material'
// import axios from 'axios'

const defaultSelectOption = { value: constants.defaultSelect, label: constants.defaultSelect }
const CUSTOM = 'CUSTOM'
let title = ''
// const NEW_FILE = 'New File'
const useStandardTemplate = 'useStandardTemplate'

let templateTypeSelected = ''

const VerticalDivider = () =>
  <YDivider height='20px' /> 

const BottomPaddedButton = props =>
  <>
    <ThemeButton {...props} />
    <VerticalDivider />
  </>

const PageButtons = props =>
  <>
    <CancelButton id={'createJob_cancel'} onClick={props.handleCancel} arrRefs={props.arrRefs} />
    <XDivider width='10px' />
    {
      props?.showTable &&
      <>
        <SaveButton id={'createJob_saveJobForLater'} disabled={Object.keys(props.validationErrors).length > 0} variant='outlined' arrRefs={props.arrRefs} postService={props.handleSaveJobForLater} saveLabel='buttons.saveJobForLater' />
        <XDivider width='10px' />
        <SaveButton id={'createJob_saveAndAssignJob'} disabled={Object.keys(props.validationErrors).length > 0 || isSupervisor() || isDataEntryUser()} arrRefs={props.arrRefs} postService={props.handleSaveAndAssignJob} saveLabel='buttons.saveAndAssignJob' />
        <XDivider width='10px' />
        <SaveButton id={'createJob_saveAndAssignJob'} disabled={Object.keys(props.validationErrors).length > 0} arrRefs={props.arrRefs} postService={props.handleSaveAndAssignJobWithoutTemplate} saveLabel='buttons.saveAndAssignJobWithoutTemplate' />
      </>
    }
  </>

PageButtons.propTypes = {
  arrRefs: PropTypes.array,
  handleSaveJobForLater: PropTypes.func,
  handleCancel: PropTypes.func,
  handleSaveAndAssignJob: PropTypes.func,
  handleSaveAndAssignJobWithoutTemplate: PropTypes.func,
  validationErrors: PropTypes.object
}

const CancelButtons = props => 
  <>
    <CancelButton id={'createJob_cancel'} onClick={props.handleCancel} arrRefs={props.arrRefs} />
  </>

CancelButtons.propTypes = {
  handleCancel: PropTypes.func
}


const ButtonsForSaveJobsForLater = props =>
  <>
    <CancelButton id={'createJob_DialogBox_cancel'} arrRefs={props.arrRefs} onClick={closeGeneralDialog} />
    <SaveButton id={'createJob_DialogBox_saveJob'} arrRefs={props.arrRefs} postService={props.postService} saveLabel='buttons.saveJob' />
  </>

ButtonsForSaveJobsForLater.propTypes = {
  arrRefs: PropTypes.array,
  postService: PropTypes.func
}

// const SELECT_COUNTRY = 0
// const SELECT_WMS = 1
// const SELECT_DISTRICT = 2
const SELECT_ORDER_NUMBER = 3
const SELECT_ACOUNT_LEVEL1 = 4
const SELECT_ACOUNT_LEVEL2 = 5
const SELECT_ACOUNT_LEVEL3 = 7
const SELECT_TEMPLATE_TYPE = 9
const SELECT_TEMPLATE_NAME = 10
// const FIELD_TOOL_BOXES = 11
const DATE_PICKUP = 12
const DATE_TARGET = 13
const FIELD_TEMPLATE_NAME = 14
// const ONEIL_SYSTEM = 'ONEIL'
// const SKP_SYSTEM = 'SKP'
// const SKP_INSTANCE = 16
const CHECK_FIELD = 17
const CHECK_CHARGE = 18
const UPLOAD_CUSTOMER_DATA_FILE = 19
const QUALITY_CHECK = 20
const BARCODE_LOGIC = 21

const getService = async (setState) => {
  const getObject = {
  }
  return Promise.resolve(getObject)
}

// const templateTypes = [{value: '--Select--', label: '--Select--'}, {value: 'Maintenance Box', label: 'Maintenance Box'}, {value: 'Maintenance File', label: 'Maintenance File'},  
// {value: 'New Box', label: 'New Box'}, 
// {value: 'New File', label: 'New File'}]

const initialSate = {
  chargeDisabled: true,
  showTable: false,
  countries: [defaultSelectOption],
  templates: [defaultSelectOption],
  templatesForSelect: [defaultSelectOption],
  workerDetails: [defaultSelectOption],
  workerDetailsGde: null,
  wmsList: [defaultSelectOption],
  templateTypeList: [],
  skpInstance: [defaultSelectOption],
  selectedWms: '',
  selectedTemplate: '',
  isQualityCheck: true,
  disircts: [defaultSelectOption],
  typingTimeOut: 0,
  selectedTemplateValues: [],
  WMSDistrictBuildings: [],
  WMSForAC: null,
  WMSSystem: null,
  accountLevel1Description: '',
  validationErrors: {},
  templateTypeState: '',
  templateInstructions: '',
  changeTemplateInstructions: '',
  existingTemplateInstructions: '',
  isEdit: false,
  copyTemplateData: false,
  openCustomFieldsDialog: false,
  saveStandardTempValues: [],
  addedCustomFields: [],
  renderNewTemplate: false,
  isCustomFieldsNotAdded: true,
  selectedCustomTemplateFields: [],
  selectedCustomTemplateFieldNames: [],
  selectedStandardTemplateFieldNames: [],
  enableAddFieldsBtn: true,
  isTemplateChanged: false,
  hideManualTransmitCheckbox: false,
  disableManualTransmitCheckbox: false,
  wmsInstance: '',
  countryCode: '',
  districtId: '',
  country: '',
  errorMsg: '',
  showForm: false,
  wmsForCountry: '',
  skpEncoding: {}
}


const CreateJob = () => {
  const { t } = useTranslation()
  const refLocalBusyCursor = useRef(null)
  const [state, setState, getState] = useMergeState(initialSate)
  // const [showOrderCount, setShowOrderCount] = useState(false)
  const [isChecked, setIsChecked] = useState(true)
  const [isAutoTransmitForCopyJob, setIsAutoTransmitForCopyJob] = useState(false)
  // const [enableChecked, setEnableChecked] = useState(false)
  const tableRef = useRef()
  const refLocalToast = useRef(null)
  const history = useHistory()
  // eslint-disable-next-line
  const { workerId: customerId, email: customerEmail = '', countryCode, role } = getUser()
  const location = useLocation()
  const pathParams = location.pathname.split('/')
  const copyJobId = pathParams[2] || false
  const [open, setOpen] = React.useState(true)
  let createTempPerms = true

  // const [Accountdata, setData] = useState([])
  // 

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const docId = 'CZ099|9902|990201'
  //       const response = await axios.get(`https://us-central1-irm-eap-edp-mobile-sandbox.cloudfunctions.net/grpGde-AccountDataAPI?docId=${docId}`)
  //       setData(response.data)
  //     } catch (error) {
  //       console.error(error)
  //     }
  //   }

  //   fetchData()
  // }, [])

  const additionalGivenPermissions = window?.sessionStorage?.getItem('additional-permissions-user')
  if (additionalGivenPermissions !== undefined && additionalGivenPermissions !== 'undefined') {
    const additionalPermissionsForUser = JSON.parse(additionalGivenPermissions)
    const indexOfCreateTemplate = additionalPermissionsForUser?.map(object => object.value).indexOf('createTemplate')
    const getTemplatePermissions = () => {
      if (role === 'USER') {
        return false
      } else if (role === 'SUPERVISOR') {
        if (additionalPermissionsForUser?.[indexOfCreateTemplate]?.enabled) {
          return true 
        } else {
          return false
        }
      } else {
        return true
      }
    }
    createTempPerms = getTemplatePermissions()
  }

  const handleClose = () => {
    setOpen(false)
    setState({ showTable: true })
  }

  useEffect(() => {
    setBusy()
    // getCountries()
    getWorkerDetails(customerId, copyJobId)
    // onChangeDistrict()
    clearBusy()
  }, [])

  let newBarcodeFlow = window?.localStorage?.getItem('persist-filters-barcodeLogic')
  if (newBarcodeFlow === 'true') {
    newBarcodeFlow = true 
  } else {
    newBarcodeFlow = false
  }

  const formTemplate = [
    {
      label: 'templates.country',
      fieldKey: 'countryCode',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'templates.associatedWMSSystem',
      fieldKey: 'wmsCode',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'templates.district',
      fieldKey: 'districtId',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'templates.orderNumber',
      fieldKey: 'orderNumber',
      isRequired: false
    },
    {
      label: 'templates.accountLevelOne',
      fieldKey: 'accountLevel1',
      defaultValue: '',
      isRequired: true
    },
    {
      label: 'templates.accountLevelTwo',
      fieldKey: 'accountLevel2',
      defaultValue: '',
      isDisable: true
    },
    {
      fieldKey: 'obj.obj1.check',
      defaultValue: false
    },
    {
      label: 'templates.accountLevelThree',
      fieldKey: 'accountLevel3',
      defaultValue: '',
      isDisable: true
    },
    {
      fieldKey: 'obj.obj1.check2',
      defaultValue: false
    },
    {
      label: 'templates.templateType',
      fieldKey: 'deType',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'templates.templateName',
      fieldKey: 'templateName',
      defaultValue: constants.defaultSelect,
      isRequired: true
    },
    {
      label: 'templates.totalBoxes',
      fieldKey: 'totalBoxes',
      defaultValue: '',
      isRequired: true,
      regx: regx.digitsRegx,
      regxError: regx.digitsRegxError,
      maxLength: 4
    },
    {
      label: 'templates.pickupDate',
      fieldKey: 'pickupDate',
      defaultValue: today,
      isRequired: true,
      validator: value => onSelectionFromDate(value),
    },
    {
      label: 'templates.targetDate',
      fieldKey: 'targetDate',
      defaultValue: afterThirtyDaysFromToday,
      isRequired: true,
      validator: value => onSelectionToDate(value),
    },
    {
      label: 'templates.templateName',
      fieldKey: 'templateName',
      maxLength: 60,
      regx: regx.alphanumericRegex,
      regxError: regx.alphanumericRegexError,
    },
    {
      label: 'templates.boxCountSubmit',
      fieldKey: 'boxCountForSubmittion',
      isRequired: true,
      regx: regx.digitsRegx,
      regxError: regx.digitsRegxError,
      defaultValue: '10',
      minValue: '0',
      maxValue: '10'
    },
    {
      label: 'templates.skpinstance',
      fieldKey: 'skpinstance',
      isRequired: true
    },
    {
      label: 'demo.manualTransmitJob',
      fieldKey: 'autoTransmit',
      defaultValue: false
    },
    {
      label: 'demo.chargeForMaintenance',
      fieldKey: 'chargeForMaintenance',
      defaultValue: true
    },
    {
      label: 'demo.uploadCustomerDataFile',
      fieldKey: 'uploadCustomerDataFile',
      defaultValue: false
    },
    {
      label: 'demo.qualityCheck',
      fieldKey: 'qualityCheck',
      defaultValue: false
    },
    {
      label: 'demo.barcodeLogic',
      fieldKey: 'barcodeLogic',
      defaultValue: newBarcodeFlow
    },
  ]

  const [arrRefs, data] = useFormPageHandler({
    formTemplate,
    service: getService,
    busyOverride: refLocalBusyCursor,
  })

  const getTemplatesForTemplateType = async (templateType, wms) => {
    setBusy()
    const accLevel1 = arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue()
    const collection = await gdeTransactions.getTemplates(templateType, accLevel1)
    const useStandardTemplateOption = { value: useStandardTemplate, label: translate('templates.useStandardTemplate') }
    let templateList = [defaultSelectOption]
    if (templateType !== constants.defaultSelect && (collection.size === 0 || collection.size > 0)) {
      if (isSupervisor() || isDataEntryUser()) {
        templateList = [defaultSelectOption]
      } else { templateList = [defaultSelectOption, useStandardTemplateOption] }
    }
    const templateDetailsList = {}
    collection?.forEach((doc) => {
      const data = doc.data()
      // eslint-disable-next-line
      data?.isActive === false ? null : templateList.push({ value: doc.id, label: doc.id })
      templateDetailsList[doc.id] = doc
    })

    if (getState()?.copyTemplateData && getState()?.copyTemplateData?.templateName.includes('NoReuse-')) {
      templateList.push({ value: getState()?.copyTemplateData?.templateName, label: getState()?.copyTemplateData?.templateName })
      arrRefs[SELECT_TEMPLATE_NAME].current.setValue(getState()?.copyTemplateData?.templateName)
    }
    setState({ templates: templateDetailsList, templatesForSelect: templateList, selectedTemplate: '' })
    if (getState()?.copyTemplateData && !getState()?.copyTemplateData?.templateName.includes('NoReuse-')) {
      arrRefs[SELECT_TEMPLATE_NAME].current.setValue(getState()?.copyTemplateData?.templateName)
    }
    clearBusy()
  }

  // backend data conversion for template types
  state.templateTypeList.forEach((element, index) => {
    if (element.label !== '--Select--') {
      element.label = t(`templateTypeObj.${element.value}`)
    }
  })

  const getTemplateTypes = async (wms) => {
    setBusy()
    const collection = await gdeTransactions.getTemplateTypesForWms(wms)
    const templateTypes = [defaultSelectOption]
    const standardTemplates = {}
    collection.forEach((doc) => {
      if (doc.data()?.assetType !== 'BOX TRANSMITTAL') {
        templateTypes.push({ value: doc.data().dataEntryType, label: doc.data().dataEntryType })
        standardTemplates[doc.data().dataEntryType] = doc.data()
      }
    })
    setState({ templateTypeList: templateTypes, standardTemplates: standardTemplates })
    clearBusy()
  }
  const getWms = async (countryCode) => {
    setBusy()
    const wmsSystems = []
    const wmsForList = [defaultSelectOption]
    const collection = await gdeTransactions.getWmsSystemFroCountry(countryCode)
    const buildings = []
    collection.forEach((doc) => {
      buildings.push(doc.data())
      let wms = doc.data().wms
      if (wms !== undefined && wms !== null) {
        wms = wms.toUpperCase()
        if (!wmsSystems.includes(wms) && wms === 'SKP') {
          wmsSystems.push(wms)
          wmsForList.push({ value: wms, label: wms })
        }
      }
    })

    if (wmsSystems.length === 1) {
      setState({ selectedWms: wmsSystems[0], wmsList: wmsForList, WMSDistrictBuildings: buildings })
    } else {
      setState({ wmsList: wmsForList })
    }
    clearBusy()
  }

  // const getDistricts = async (countryName) => {
  //   setBusy()
  //   const collection = await gdeTransactions.getLocationsForCountry(countryName)
  //   const districtsList = [defaultSelectOption]
  //   collection.forEach((doc) => {
  //     districtsList.push({ value: doc.data().districtName, label: doc.data().districtName })
  //   })
  //   setState({ disircts: districtsList })
  //   clearBusy()
  // }

  const getCopyJobData = async (copyJobId) => {
    setBusy()
    getTemplateTypes(getState().selectedWms)
    const jobDocument = await gdeTransactions.getJobById(copyJobId)
    const jobDoc = jobDocument.data()
    await getTemplatesForTemplateType(jobDoc?.dataEntryType, getState().selectedWms)
    const copyTemplateData = jobDoc?.templateData
    setState({
      copyTemplateData: copyTemplateData, resetBtn: true, showForm: true
    })

    if (jobDoc?.templateName === 'skpStandardNewFile' || jobDoc?.templateName === 'skpStandardNewBox' || jobDoc?.templateName === 'skpStandardMaintenanceFile' || jobDoc?.templateName === 'skpStandardMaintenanceBox') {
      jobDoc.templateName = useStandardTemplate
    }
    arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(true)
    arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
    arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
    arrRefs[SELECT_ACOUNT_LEVEL1].current.setValue(jobDoc?.accountLevel1)
    arrRefs[SELECT_ACOUNT_LEVEL2].current.setValue(jobDoc?.accountLevel2)
    arrRefs[SELECT_ACOUNT_LEVEL3].current.setValue(jobDoc?.accountLevel3)
    arrRefs[SELECT_TEMPLATE_TYPE].current.setValue(jobDoc?.dataEntryType)
    arrRefs[SELECT_TEMPLATE_NAME].current.setValue(jobDoc?.templateName)
    if ((jobDoc?.dataEntryType === 'New File' || jobDoc?.dataEntryType === 'Maintenance File') && getState().workerDetails.countryCode !== 'gb') {
      let manualTransmit = false
      if (jobDoc?.autoTransmit === 'true') {
        manualTransmit = false
      } else if (jobDoc?.autoTransmit === 'false') {
        manualTransmit = true
      }
      arrRefs[CHECK_FIELD]?.current?.setValue(manualTransmit)
      setIsAutoTransmitForCopyJob(manualTransmit)
    }

    if (jobDoc?.dataEntryType === 'Maintenance Box' || jobDoc?.dataEntryType === 'Maintenance File') {
      setIsChecked(copyTemplateData?.templateFields?.maintenanceCode?.defaultValue === 'C')
    }

    if (jobDoc?.dataEntryType === 'New File') {
      arrRefs[UPLOAD_CUSTOMER_DATA_FILE].current.setValue(jobDoc?.isUploadCustomerDataFile)
    }
    arrRefs[QUALITY_CHECK]?.current?.setValue(jobDoc?.qualityCheck)

    setState({ isQualityCheck: jobDoc?.qualityCheck })
    clearBusy()
  }

  const getCountries = async () => {
    const collection = await gdeTransactions.getCountries()
    const countryList = []
    collection.forEach((doc) => {
      countryList.push({ value: doc.id, label: `${doc.id}-${doc.data().countryName}`, wms: doc?.data()?.wms })
    })
    setState({ countries: countryList })
  }

  const getSkpInstance = async (countryName) => {
    const doc = await gdeTransactions.getCountrySkpInstance(countryName)
    doc?.docs?.forEach((doc) => {
      setState({ skpInstance: doc?.data()?.skpInstance, wmsInstance: doc?.data()?.skpInstance })
    })
    doc?.docs?.forEach((doc) => {
      if (doc.data()?.wms?.skp !== undefined || doc.data()?.wms?.skp !== 'undefined') {
        setState({ wmsForCountry: 'SKP' }) 
      }
    })
    await getTemplateTypes(getState()?.wmsInstance)
  }

  const getWorkerDetails = async (userId, copyJobId = false) => {
    const workerDetails = await gdeTransactions.getWorkerDetails(userId)
    const workerDetailsGde = await gdeTransactions.getWorkerRoleGde(userId)
    const workerUserRoles = await gdeWorkerRole(userId)
    const districtString = workerUserRoles.data().district[0]
    const [, , , , skpEncoding] = await gdeTransactions.getGdeConfig()
    await updateWorkerRoleDistrict(userId, districtString)
    await getWms(workerDetails.countryCode)
    await getSkpInstance(workerDetailsGde?.gdeCountry || workerDetails?.country)
    await getTemplateTypes(getState()?.wmsForCountry)
    setState({ skpEncoding: skpEncoding, workerDetails: workerDetails, workerDetailsGde: workerDetailsGde, countryCode: workerDetailsGde?.gdeCountryCode || workerDetails?.countryCode, districtId: workerDetailsGde?.district[0] || workerDetails?.gdeDistrict || workerDetails?.district, country: workerDetailsGde?.gdeCountry || workerDetails?.country })
    // arrRefs[SELECT_COUNTRY].current.setValue(getState().workerDetails.countryCode)
    // arrRefs[SELECT_DISTRICT].current.setValue(getState().workerDetails.gdeDistrict)
    // arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(true)
    // arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
    // arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
    arrRefs[SELECT_ACOUNT_LEVEL1].current.focus()
    // const checkSkpInstance = countryConfig.find(entry => entry.countryCode === getState()?.countryCode)
    // if (checkSkpInstance) {
    //   setState({ skpInstance: 'AMER', wmsInstance: 'AMER' })
    // } else {
    //   setState({ skpInstance: 'EURO', wmsInstance: 'EURO' })
    // }
    // this if-else loop is for the auto selection of WMS instance
    // let wmsAvailable = false
    // if (state.wmsList.length < 3) {
    //   selectskpinstance.forEach(wmsInstance => {
    //     if (wmsInstance.label === workerDetailsGde?.wmsInstance) {
    //       wmsAvailable = true
    //     }
    //   })
    //   // wmsAvailable && arrRefs[SKP_INSTANCE].current.setValue(workerDetailsGde?.wmsInstance)
    //   // wmsAvailable && onChangeskpinstance(workerDetailsGde.wmsInstance)
    // } else if (state.wmsList.length > 2) {
    //   state.wmsList.forEach(wmsInstance => {
    //     if (wmsInstance.label === workerDetailsGde?.wmsInstance) {
    //       wmsAvailable = true
    //     }
    //   })
    //   wmsAvailable && arrRefs[SELECT_WMS].current.setValue(workerDetailsGde?.wmsInstance)
    //   wmsAvailable && onChangeWms(workerDetailsGde.wmsInstance)
    // }


    copyJobId && getCopyJobData(copyJobId)
  }

  const getTemplateFields = async () => {
    let fields
    if (getState().selectedTemplate === useStandardTemplate) {
      fields =
        getState().standardTemplates[
          arrRefs[SELECT_TEMPLATE_TYPE].current.getValue()
        ].templateFields
      try {
        setState({
          existingTemplateInstructions:
            getState().standardTemplates[
              arrRefs[SELECT_TEMPLATE_TYPE].current.getValue()
            ].templateInstructions
        })
      } catch {
        // console.log('no instructions')
      }
    } else {
      if (
        copyJobId &&
        !arrRefs[SELECT_TEMPLATE_NAME].current.getValue().includes('NoReuse-')
      ) {
        const accLevel1 = arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue()
        const templateType = arrRefs[SELECT_TEMPLATE_TYPE].current.getValue()
        const selectedTemplate =
          arrRefs[SELECT_TEMPLATE_NAME].current.getValue()
        const collection = await gdeTransactions.getTemplates(
          templateType,
          accLevel1
        )
        const useStandardTemplateOption = {
          value: useStandardTemplate,
          label: translate('templates.useStandardTemplate')
        }
        let templateList = [defaultSelectOption]
        if (
          templateType !== constants.defaultSelect &&
          (collection.size === 0 || collection.size > 0)
        ) {
          templateList = [defaultSelectOption, useStandardTemplateOption]
        }

        const templateDetailsList = {}
        collection.forEach((doc) => {
          templateList.push({ value: doc.id, label: doc.id })
          templateDetailsList[doc.id] = doc
        })

        if (
          getState()?.copyTemplateData &&
          getState()?.copyTemplateData?.templateName.includes('NoReuse-')
        ) {
          templateList.push({
            value: getState()?.copyTemplateData?.templateName,
            label: getState()?.copyTemplateData?.templateName
          })
        }

        setState({
          templates: templateDetailsList,
          templatesForSelect: templateList,
          selectedTemplate: selectedTemplate
        })

        fields = templateDetailsList[selectedTemplate].data().templateFields
      } else if (
        copyJobId &&
        getState()?.copyTemplateData !== false &&
        arrRefs[SELECT_TEMPLATE_NAME].current.getValue().includes('NoReuse-')
      ) {
        fields = getState()?.copyTemplateData?.templateFields
      } else {
        fields =
          getState().templates[getState().selectedTemplate].data()
            .templateFields
      }

      try {
        setState({
          existingTemplateInstructions:
            getState().templates[getState().selectedTemplate].data()
              .templateInstructions
        })
      } catch {
        // console.log('no instructions')
      }
    }
    let finalArrayFields
    const arrayFields = Object.keys(fields).map((key) => {
      const data = fields[key]
      data.name = key
      return data
    })
    getState().renderNewTemplate && !state.isTemplateChanged
      ? (finalArrayFields = getState().addedCustomFields)
      : (finalArrayFields = arrayFields)
    getState().renderNewTemplate && !state.isTemplateChanged && setState({ showTable: true })
    finalArrayFields.sort((a, b) =>
      a.customOrder > b.customOrder ? 1 : b.customOrder > a.customOrder ? -1 : 0
    )
    !getState().renderNewTemplate ? setState({ selectedCustomTemplateFields: finalArrayFields }) : state.isTemplateChanged && setState({ selectedCustomTemplateFields: finalArrayFields })
    // defaulting date
    const checkCountry = countryConfig.find(entry => entry.countryCode === getState()?.countryCode)
    finalArrayFields.forEach((field) => {
      if (field?.dataType === 'Date') {
        if (checkCountry) {
          field.customFormat = checkCountry.dateFormat
        } else {
          field.customFormat = defaultDateFormat2
        }
      }
    })
    return Promise.resolve(finalArrayFields)
  }

  const handleAddInst = () => {
    return (
      createTempPerms 
        ? openGeneralDialog({
          title: t('forms.enterInstructions'),
          noTranslateTitle: true,
          message: <ContentforInstructionsBox />,
          buttons: <ButtonsforInstructionBox />
        }) 
        : openGeneralDialog({
          title: t('forms.viewTemplateInstructions'),
          noTranslateTitle: true,
          message: <ContentforInstructionsBox />,
          buttons: <ButtonsforCloseInstructionBox />
        })
    )
  }

  const ContentforInstructionsBox = () => {
    return (
      <TextareaAutosize
        aria-label="empty textarea"
        placeholder= {createTempPerms ? t('forms.enterInstructions') : null}
        label={createTempPerms ? t('forms.enterInstructions') : t('buttons.viewTemplateInstructions')}
        style={{ width: 500, height: 50 }}
        onBlur={(e) => setState({ templateInstructions: e.target.value })}
        defaultValue={getState().existingTemplateInstructions || getState().changeTemplateInstructions}
        disabled={!createTempPerms}
      />
    )
  }
  const ButtonsforInstructionBox = () => {
    return (
      <>
        <BottomPaddedButton color='primary' variant='outlined' onClick={closeGeneralDialog}>buttons.cancel</BottomPaddedButton>
        <BottomPaddedButton color='primary' variant='contained' onClick={handleInstructionsSave}>buttons.save</BottomPaddedButton>
      </>
    )
  }

  const ButtonsforCloseInstructionBox = () => {
    return (
      <>
        <BottomPaddedButton color='primary' variant='outlined' onClick={closeGeneralDialog}>buttons.close</BottomPaddedButton>
      </>
    )
  }

  const handleInstructionsSave = () => {
    setState({ changeTemplateInstructions: getState().templateInstructions || getState().existingTemplateInstructions })
    setTimeout(successToast({ message: t('toast.templateInstructionsSaved') }, 50000))
    closeGeneralDialog()
  }

  const checkIsTemplateFiledValuesChanged = () => {
    let intialTemplateValues = JSON.parse(getState().selectedTemplateValues)
    intialTemplateValues = intialTemplateValues.map((obj) => {
      if (!('instructionData' in obj)) {
        obj.instructionData = ''
      }
      return obj
    })
    const templateValuesFromtable = tableRef.current.dataManager.data
    const newtemplateValuesFromtable = templateValuesFromtable.map((data, index) => {
      if (data.tableData) {
        const { id, editCellList, ...tableData } = data.tableData
        return { ...data, tableData }
      }
      return data
    })
    return (
      isEqual(intialTemplateValues, newtemplateValuesFromtable) &&
      isEmpty(getState().changeTemplateInstructions) &&
      isEqual(getState().selectedCustomTemplateFields, templateValuesFromtable)
    )
  }

  const ButtonsForSaveAndAssignJob = props =>
    <>
      <BottomPaddedButton color='primary' variant='outlined' onClick={closeGeneralDialog}>buttons.cancel</BottomPaddedButton>
      <SaveButton arrRefs={props.arrRefs} postService={props.saveAndAssignJob} saveLabel='buttons.saveJob' />
    </>

  ButtonsForSaveAndAssignJob.propTypes = {
    arrRefs: PropTypes.array,
    saveAndAssignJob: PropTypes.func
  }

  const ButtonsForSaveAndAssignJobWithoutTemplate = props =>
    <>
      <BottomPaddedButton color='primary' variant='outlined' onClick={closeGeneralDialog}>buttons.cancel</BottomPaddedButton>
      <SaveButton arrRefs={props.arrRefs} postService={props.saveAndAssignJobWithoutTemplate} saveLabel='buttons.saveJob' />
    </>

  ButtonsForSaveAndAssignJobWithoutTemplate.propTypes = {
    arrRefs: PropTypes.array,
    saveAndAssignJobWithoutTemplate: PropTypes.func
  }

  const ContentForDialogBox = (props) =>
    <>
      <Label>messages.saveNewJobMessage</Label>
      <VerticalDivider />
      <TextField
        data={data}
        fieldTemplate={formTemplate[FIELD_TEMPLATE_NAME]}
        ref={arrRefs[FIELD_TEMPLATE_NAME]}
        startString={props.namePrefix()}
        noTranslateStartString
      />
    </>

  ContentForDialogBox.propTypes = {
    namePrefix: PropTypes.func
  }

  const ContentForDialogBoxWithoutTemplateCreate = (props) =>
    <>
      <Label>messages.saveNewJobWithoutTemplateMessage</Label>
    </>

  ContentForDialogBoxWithoutTemplateCreate.propTypes = {}

  const ContentForSaveLaterDialogBox = (props) =>
    <>
      <Label>messages.saveNewJobMessage</Label>
      <VerticalDivider />
      <TextField
        data={data}
        fieldTemplate={formTemplate[FIELD_TEMPLATE_NAME]}
        ref={arrRefs[FIELD_TEMPLATE_NAME]}
        startString={props.namePrefix()}
        noTranslateStartString
      />
    </>

  ContentForSaveLaterDialogBox.propTypes = {
    namePrefix: PropTypes.func
  }

  const saveAndAssignJobWithoutTemplate = (postObject, isCreateCustomTemplate = true) => {
    saveJob(postObject, `${routePaths.assignJob}`, isCreateCustomTemplate, false)
    closeGeneralDialog()
  }

  const saveAndAssignJob = (postObject, isCreateCustomTemplate = true) => {
    saveJob(postObject, `${routePaths.assignJob}`, isCreateCustomTemplate)
  }

  const saveJobForLater = (postObject, isCreateCustomTemplate = true) => {
    saveJob(postObject, undefined, isCreateCustomTemplate)
  }

  const checkAdditionalFieldForStandardTemplate = () => {
    if (getState()?.selectedTemplate === useStandardTemplate || arrRefs[SELECT_TEMPLATE_NAME].current.getValue() === useStandardTemplate) {
      let noOfFieldsInOriginalTemplate = 0
      let noOfFieldsInModifiedTemplate = 0
      const intialTemplateValues = JSON.parse(getState().selectedTemplateValues)
      const templateValuesFromtable = tableRef.current.dataManager.data

      templateValuesFromtable.forEach((data, index) => {
        if (data.tableData) {
          if (data.tableData.checked) {
            noOfFieldsInModifiedTemplate++
          }
        }
        return noOfFieldsInModifiedTemplate
      })

      intialTemplateValues.forEach((data, index) => {
        if (data.tableData) {
          if (data.tableData.checked) {
            noOfFieldsInOriginalTemplate++
          }
        }
        return noOfFieldsInOriginalTemplate
      })

      if (noOfFieldsInOriginalTemplate >= noOfFieldsInModifiedTemplate) {
        handleAdditionalFieldPopUp()
        return false
      } else {
        return true
      }
    } else {
      return true
    }
  }

  const handleAdditionalFieldPopUp = () => {
    openGeneralDialog({
      title: t('options.aaditionFieldWarning'),
      message: t('options.aaditionFieldMessage'),
      noTranslate: true,
      noTranslateTitle: true,
      buttons: <ButtonsForAdditionalFieldDialog />,
      closeX: true
    })
  }

  const ButtonsForAdditionalFieldDialog = () =>
    <>
      <ContainedButton onClick={closeGeneralDialog} >buttons.Ok</ContainedButton>
    </>

  const handleSaveAndAssignJobWithoutTemplate = async (postObject) => {
    const result = checkAdditionalFieldForStandardTemplate()
    if (result) {
      openGeneralDialog({
        title: t('templates.saveAndAssignJobWitoutTemplateCreate'),
        noTranslateTitle: true,
        message: <ContentForDialogBoxWithoutTemplateCreate />,
        buttons: <ButtonsForSaveAndAssignJobWithoutTemplate arrRefs={arrRefs} saveAndAssignJobWithoutTemplate={saveAndAssignJobWithoutTemplate} />,
        closeX: true
      })
    }
  }

  const handleSaveAndAssignJob = async (postObject) => {
    const result = checkAdditionalFieldForStandardTemplate()
    if (result) {
      const isValuesEqual = checkIsTemplateFiledValuesChanged()
      if (isValuesEqual) {
        saveAndAssignJob(postObject, false)
      } else {
        openGeneralDialog({
          title: t('templates.saveAndAssignJob'),
          noTranslateTitle: true,
          message: <ContentForDialogBox namePrefix={getTemplateNamePrefix} />,
          buttons: <ButtonsForSaveAndAssignJob arrRefs={arrRefs} saveAndAssignJob={saveAndAssignJob} />,
          closeX: true
        })
      }
    }
  }

  const handleSaveJobForLater = async (postObject) => {
    const result = checkAdditionalFieldForStandardTemplate()
    if (result) {
      // if template values not changed then no need to create a custom template
      const isValuesEqual = checkIsTemplateFiledValuesChanged()
      if (isValuesEqual) {
        saveJobForLater(postObject, false)
      } else {
        openGeneralDialog({
          title: t('options.saveJobForLater'),
          noTranslateTitle: true,
          message: <ContentForSaveLaterDialogBox namePrefix={getTemplateNamePrefix} />,
          buttons: <ButtonsForSaveJobsForLater arrRefs={arrRefs} postService={saveJobForLater} />,
          closeX: true
        })
      }
    }
  }

  // TODO : This function will be removed or blocked after completion of #416
  const createCustomTemplate = async (postObject, customTemplateName, isReusable = true) => {
    const arrPost = tableRef.current.dataManager.data
    const fields = {}
    let costomOrder = 1
    arrPost.forEach(r => {
      if (r.tableData.checked) {
        delete r.rowSelected
        delete r.tableData
        const fieldName = r.name
        delete r.name
        delete r.isRequiredChanged
        r.customOrder = costomOrder
        costomOrder++
        fields[fieldName] = r
      }
    })
    const dateVal = new Date()
    const templateData = {
      countryCode: getState()?.countryCode,
      wmsCode: getState().selectedWms,
      accountLevel1: postObject.accountLevel1.toUpperCase(),
      accountLevel2: postObject.accountLevel2.toUpperCase(),
      accountLevel3: postObject.accountLevel3.toUpperCase(),
      // skpinstance: (getState().WMSSystem === SKP_SYSTEM && postObject.skpinstance !== undefined) ? postObject.skpinstance : '',
      skpinstance: getState()?.skpInstance,
      dataEntryType: postObject.deType,
      templateType: CUSTOM,
      standardTemplateName: getState().standardTemplates[arrRefs[SELECT_TEMPLATE_TYPE].current.getValue()].templateName,
      templateName: customTemplateName,
      templateFields: fields,
      createdBy: customerEmail || customerId,
      createdTs: dateVal,
      lastUsed: dateVal,
      templateInstructions: getState().changeTemplateInstructions || getState().existingTemplateInstructions || ''
    }
    if (Object.keys(fields).length !== 0 && isReusable) {
      await gdeTransactions.createTemplate(templateData)
      return templateData
    } else if (Object.keys(fields).length !== 0 && !isReusable) {
      return templateData
    } else {
      history.goBack()
    }
  }

  const getJobDoc = (postObject, customTemplateName, customTemplateData, jobId) => {
    if (getState().templateTypeState === 'Maintenance Box' || getState().templateTypeState === 'New Box' || getState().templateTypeState === 'Maintenance File' || getState().templateTypeState === 'New File') {
      //   postObject.autoTransmit = true
      //   postObject.totalBoxes = totalNoOfBoxesForJob
      // } else {
      postObject.totalBoxes = totalNoOfBoxesForJob
    }

    let autoTransmit
    let autoTransmitAndStatus

    if (getState().workerDetails.countryCode === 'gb' && getState()?.disableManualTransmitCheckbox) {
      autoTransmit = 'false'
      autoTransmitAndStatus = `${'false'}-${constants.jobStatus.pending}`
    } else if (getState().workerDetails.countryCode !== 'gb' && (getState().templateTypeState === 'Maintenance Box' || getState().templateTypeState === 'New Box')) {
      autoTransmit = 'false'
      autoTransmitAndStatus = `${'false'}-${constants.jobStatus.pending}`
    } else {
      autoTransmit = postObject.autoTransmit === true ? 'false' : 'true'
      autoTransmitAndStatus = `${postObject.autoTransmit === true ? 'false' : 'true'}-${constants.jobStatus.pending}`
    }

    let barcodeLogic
    if (postObject?.barcodeLogic) {
      barcodeLogic = newBarcodeLogic
      window.localStorage.setItem('persist-filters-barcodeLogic', JSON.stringify(true))
    } else {
      barcodeLogic = originalBarcodeLogic
      window.localStorage.setItem('persist-filters-barcodeLogic', JSON.stringify(false))
    }

    const date = new Date()
    const jobDoc = {
      jobId: jobId,
      jobStatus: constants.jobStatus.pending,
      standardTemplateName: getState().standardTemplates[arrRefs[SELECT_TEMPLATE_TYPE].current.getValue()].templateName,
      dataEntryType: postObject.deType,
      isUploadCustomerDataFile: postObject?.uploadCustomerDataFile ? postObject?.uploadCustomerDataFile : false,
      accountLevel1: postObject.accountLevel1.toUpperCase(),
      accountLevel2: postObject.accountLevel2.toUpperCase(),
      accountLevel3: postObject.accountLevel3.toUpperCase(),
      orderNumber: postObject.orderNumber ? postObject.orderNumber : '',
      autoTransmit: autoTransmit,
      autoTransmitAndStatus: autoTransmitAndStatus,
      wmsInstance: '',
      wmsCode: getState().selectedWms,
      districtId: getState()?.districtId,
      countryCode: getState()?.countryCode,
      actionBy: customerId,
      actionTs: date,
      recordNotifyCount: '',
      // skpinstance: (getState().WMSSystem === SKP_SYSTEM && postObject.skpinstance !== undefined) ? postObject.skpinstance : '',
      skpinstance: getState()?.skpInstance,
      pickupDate: new Date(postObject.pickupDate),
      targetDate: new Date(postObject.targetDate),
      totalBoxes: parseInt(postObject.totalBoxes),
      exceptionBoxCount: 0,
      templateName: customTemplateName !== '' ? customTemplateName : postObject.templateName !== useStandardTemplate ? postObject.templateName : getState().standardTemplates[arrRefs[SELECT_TEMPLATE_TYPE].current.getValue()].templateName,
      templateData: customTemplateData,
      assignedUsers: {},
      createdBy: customerId,
      createdTs: date,
      boxesCompleted: 0,
      accountLevel1Description: getState().accountLevel1Description,
      qualityCheck: postObject?.qualityCheck,
      barcodeLogic: barcodeLogic
    }
    return jobDoc
  }


  const saveJob = async (postObject, routepath, isCreateCustomTemplate, isReusableTemplate = true) => {
    let customTemplateData
    let customTemplateName = isCreateCustomTemplate ? (getTemplateNamePrefix() + postObject.templateName).toUpperCase() : ''
    const templateDoc = await gdeTransactions.getTemplateById((getTemplateNamePrefix() + postObject.templateName).toUpperCase())
    const templateData = templateDoc.data()
    if (templateData !== undefined && isCreateCustomTemplate) {
      arrRefs[FIELD_TEMPLATE_NAME].current.setErrorMsg('templates.templateNameErrorMessage')
    } else {
      setBusy()
      // if true create custom template
      if (isCreateCustomTemplate && isReusableTemplate) {
        closeGeneralDialog()
        customTemplateData = await createCustomTemplate(postObject, customTemplateName, true)
      } else if (isReusableTemplate) {
        const templateDataUpdate = {
          lastUsed: new Date()
        }

        if (copyJobId && arrRefs[SELECT_TEMPLATE_NAME].current.getValue().includes('NoReuse-')) {
          customTemplateData = getState()?.copyTemplateData
        } else if (getState()?.selectedTemplate === useStandardTemplate || arrRefs[SELECT_TEMPLATE_NAME].current.getValue() === useStandardTemplate) {
          customTemplateData = getState().standardTemplates[arrRefs[SELECT_TEMPLATE_TYPE].current.getValue()]
        } else {
          customTemplateData = getState().templates[getState().selectedTemplate].data()
        }

        !arrRefs[SELECT_TEMPLATE_NAME].current.getValue().includes('NoReuse-') && postObject?.templateName && postObject?.templateName !== useStandardTemplate && await gdeTransactions.updateTemplate(postObject?.templateName, templateDataUpdate)
      } else if (!isReusableTemplate) {
        closeGeneralDialog()
        customTemplateName = `NoReuse-${getTemplateNamePrefix() + Date.now()}`
        postObject.templateName = customTemplateName
        customTemplateData = await createCustomTemplate(postObject, customTemplateName, false)
      }
      const jobs = await gdeTransactions.getJobsForUserForCurrentDate(postObject.accountLevel1.toUpperCase())
      let latestIndex = 0
      if (jobs.docs.length > 0) {
        latestIndex = parseInt(jobs.docs[0].id.split('-')[1], 10)
      }

      const date = moment(new Date()).format('MMDDYYYY')
      const jobId = `${postObject.accountLevel1.toUpperCase()}${date}-${latestIndex + 1}`
      if (routepath === undefined) {
        gdeTransactions.createJob(getJobDoc(postObject, customTemplateName, customTemplateData, jobId), jobId)
          .then(() => {
            refLocalToast.current?.successToastOn({
              message: t('toast.jobSaved', { jobId: jobId, templateName: isCreateCustomTemplate ? customTemplateName : postObject?.templateName }),
              title: t('toast.jobManagement'),
              noTranslateMessage: true,
              noTranslateTitle: true
            })
            setBusy()
            // arrRefs[SELECT_ACOUNT_LEVEL1].current.clear()
            // arrRefs[SELECT_ACOUNT_LEVEL2].current.clear()
            // arrRefs[SELECT_ACOUNT_LEVEL3].current.clear()
            // arrRefs[SELECT_TEMPLATE_TYPE].current.clear()
            // arrRefs[CHECK_FIELD].current.clear()
            // arrRefs[QUALITY_CHECK].current.clear()
            // // arrRefs[FIELD_TOOL_BOXES].current.clear()
            // getTemplateTypes('')
            // arrRefs[SELECT_TEMPLATE_NAME].current.clear()
            // getCountries()
            // getWorkerDetails(customerId)
            // setState({ isQualityCheck: false })
            // // getState()?.workerDetailsGde?.wmsInstance !== postObject.skpinstance && gdeTransactions.updateWmsInstance(customerId, postObject.skpinstance)
            // history.push(`${routePaths.root}`)
            history.push(`${routePaths.myJobs}`)
            clearBusy()
          })
      } else {
        gdeTransactions.createJob(getJobDoc(postObject, customTemplateName, customTemplateData, jobId), jobId)
          .then(() => {
            // getState()?.workerDetailsGde?.wmsInstance !== postObject.skpinstance && gdeTransactions.updateWmsInstance(customerId, postObject.skpinstance)
            history.push(`${routePaths.assignJob}/${jobId}`)
          })
      }
    }
    clearBusy()
  }

  const getTemplateNamePrefix = () => {
    const selectFieldCountry = getState()?.countryCode
    const selectFieldCustomer = arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue()
    const selectFieldDivision = arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue()
    const selectFieldDepartment = arrRefs[SELECT_ACOUNT_LEVEL3].current.getValue()

    const prefix = `${selectFieldCountry.toUpperCase()}-${selectFieldCustomer.toUpperCase()}-${selectFieldDivision ? `${selectFieldDivision.toUpperCase()}-` : 'MASTER-'}${selectFieldDepartment ? `${selectFieldDepartment.toUpperCase()}-` : 'MASTER-'}`
    return prefix
  }

  const ButtonsForCancelDialogBox = () =>
    <>
      <OutlinedButton onClick={closeGeneralDialog} >buttons.no</OutlinedButton>
      <ContainedButton onClick={handleCancelButtonOnClick} >buttons.yes</ContainedButton>
    </>

  const handleCancelButtonOnClick = () => {
    closeGeneralDialog()
    history.push(routePaths.root)
  }

  const handleCancel = () => {
    openGeneralDialog({
      title: t('options.cancelJobTitle'),
      message: t('options.cancelJobMessage'),
      noTranslate: true,
      noTranslateTitle: true,
      buttons: <ButtonsForCancelDialogBox />,
      closeX: true
    })
  }

  // const onChangeCountry = value => {
  //   setBusy()
  //   if (value !== undefined && value !== constants.defaultSelect) {
  //     const selectedcountry = getState().countries.find(country => country.value === value)
  //     setState({ WMSForAC: selectedcountry.wms, countryCode: value })
  //     getDistricts(selectedcountry.label.split('-')[1])
  //     getWms(value)
  //   }

  //   if (showOrderCount) {
  //     setShowOrderCount(false)
  //   }
  //   arrRefs[SELECT_DISTRICT].current.clear()
  //   arrRefs[SELECT_ACOUNT_LEVEL1].current.clear()
  //   arrRefs[SELECT_ACOUNT_LEVEL2].current.clear()
  //   arrRefs[SELECT_ACOUNT_LEVEL3].current.clear()
  //   arrRefs[SELECT_TEMPLATE_TYPE].current.clear()
  //   if (arrRefs[SKP_INSTANCE].current != null) {
  //     arrRefs[SKP_INSTANCE].current.clear()
  //   }
  //   getTemplateTypes('')
  //   arrRefs[SELECT_TEMPLATE_NAME].current.clear()
  //   clearBusy()
  // }

  // const onChangeDistrict = () => {
  //   const value = getState()?.districtId
  //   setBusy()
  //   if (value !== undefined && value !== constants.defaultSelect) {
  //     const buildings = getState().WMSDistrictBuildings.filter(b => b.districtName === value)
  //     const uniqueWms = buildings.map(item => item.wms).filter((value, index, self) => self.indexOf(value) === index)
  //     const wmsList = uniqueWms.filter(function (element) {
  //       return element !== undefined && element === 'SKP'
  //     })

  //     if (wmsList.length === 0) {
  //       setState({ WMSSystem: 'SKP' })
  //     } else if (wmsList.length <= 2) {
  //       setState({ WMSSystem: wmsList[0] })
  //       getTemplateTypes(wmsList).then(() => {
  //         arrRefs[SELECT_TEMPLATE_TYPE].current.setValue(NEW_FILE)
  //       })
  //     } else {
  //       arrRefs[SELECT_TEMPLATE_TYPE].current.clear()
  //       getTemplateTypes('')
  //       setState({ WMSSystem: wmsList })
  //     }
  //   }
  //   // arrRefs[SELECT_ACOUNT_LEVEL1].current.clear()
  //   // arrRefs[SELECT_ACOUNT_LEVEL2].current.clear()
  //   // arrRefs[SELECT_ACOUNT_LEVEL3].current.clear()
  //   // arrRefs[SELECT_TEMPLATE_NAME].current.clear()
  //   // if (arrRefs[SKP_INSTANCE].current != null) {
  //   //   arrRefs[SKP_INSTANCE].current.clear()
  //   // }
  //   clearBusy()
  // }

  // const onChangeCustomer = (e) => {
  //   const value = e?.target?.value
  //   if (e.keyCode === 13 && value !== '') {
  //     validateAccountLevel1(value)
  //   }
  // }

  // const onBlurCustomer = (e) => {
  //   e?.preventDefault()
  //   arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
  //   arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
  //   validateAccountLevel1(e?.target?.value)
  // }

  const getCheckedFields = async () => {
    let fields
    if (getState().selectedTemplate === useStandardTemplate) {
      fields = getState().standardTemplates[arrRefs[SELECT_TEMPLATE_TYPE].current.getValue()].templateFields
      if (fields?.maintenanceCode !== undefined) {
        isChecked ? fields.maintenanceCode.defaultValue = 'N' : fields.maintenanceCode.defaultValue = 'C'
      }
    } else {
      const MaintenanceCustomTemplateFields = state.selectedCustomTemplateFields
      for (let i = 0; i < MaintenanceCustomTemplateFields.length; i++) {
        if (MaintenanceCustomTemplateFields[i].customName === 'maintenanceCode' && MaintenanceCustomTemplateFields[i]?.defaultValue !== undefined) {
          isChecked ? MaintenanceCustomTemplateFields[i].defaultValue = 'N' : MaintenanceCustomTemplateFields[i].defaultValue = 'C'
        }
      }
    }
  }

  const handleOnChange = () => {
    setIsChecked(!isChecked)
    getCheckedFields()
  }

  const handleOnQcChange = () => {
    setState({ isQualityCheck: !getState().isQualityCheck })
  }

  // const selectskpinstance = [
  //   { value: 'AMER', label: 'AMER' },
  //   { value: 'EURO', label: 'EURO' },
  // ]

  // /*eslint-disable*/

  const validateAccountLevel1 = async (value) => {
    if (value !== '') {
    // Remove below if condition after ONEIL requirement finalized
    // if (state.WMSSystem === SKP_SYSTEM) {
      setBusy()
      validateAndGetAccountLevel1(getState()?.wmsInstance, value)
        .then(async (result) => {
          if (result) {
            const errors = getState().validationErrors
            if (result.error) {
              // arrRefs[SELECT_ACOUNT_LEVEL1].current.setErrorMsg(result.error, true)
              errors[SELECT_ACOUNT_LEVEL1] = result.error
              setState({ validationErrors: errors, errorMsg: result.error })
            }
            if (result.success && result.statusCode === 200) {
              delete errors[SELECT_ACOUNT_LEVEL1]
              setState({ validationErrors: errors, showForm: true, errorMsg: '', resetBtn: true })
              // comment the below code for getting templatetypes from array
              // await getTemplateTypes(state.selectedWms).then(() => {
              //   arrRefs[SELECT_TEMPLATE_TYPE].current.setValue(NEW_FILE)
              // })
              // arrRefs[SELECT_TEMPLATE_TYPE].current.setValue(NEW_FILE)
              arrRefs[SELECT_ACOUNT_LEVEL1].current.clearErrorMsg()
              arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
              arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
              arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(true)
              arrRefs[SELECT_ORDER_NUMBER].current.focus()
              // arrRefs[SELECT_ACOUNT_LEVEL2].current.focus()
              setState({ accountLevel1Description: result.accountLevel1Description })
            }
            clearBusy()
          }
        })
    } else {
      arrRefs[SELECT_ACOUNT_LEVEL1].current.setErrorMsg('Required', true)
      arrRefs[SELECT_ACOUNT_LEVEL2].current.clear()
      arrRefs[SELECT_ACOUNT_LEVEL3].current.clear()
      arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
      arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
      clearBusy()
    }
  }

  // const onChangeDivision = (e) => {
  //   const value = e?.target?.value
  //   if (e.keyCode === 13) {
  //     validateAccountLevel2(value)
  //   }
  // }

  // const onChangeskpinstance = () => {
  //   arrRefs[SELECT_ACOUNT_LEVEL1].current.clearErrorMsg()
  //   arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(false)
  // }

  // const onBlurDivision = (e) => {
  //   arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
  //   e?.preventDefault()
  //   validateAccountLevel2(e?.target?.value)
  // }

  const validateAccountLevel2 = (value) => {
    if (arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue() !== '') {
      // Remove below if condition after ONEIL requirement finalized
      // if (state.WMSSystem === SKP_SYSTEM) {
      setBusy()
      validateAndGetAccountLevel2(getState()?.wmsInstance, arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue(), value)
        .then(async (result) => {
          const errors = getState().validationErrors
          if (result) {
            if (result.error) {
              // arrRefs[SELECT_ACOUNT_LEVEL2].current.setErrorMsg(result.error, true)
              errors[SELECT_ACOUNT_LEVEL2] = result.error
              setState({ validationErrors: errors, errorMsg: result.error })
            }
            if (result.success && result.statusCode === 200) {
              delete errors[SELECT_ACOUNT_LEVEL2]
              setState({ validationErrors: errors, showForm: true, errorMsg: '', resetBtn: true })
              // await getTemplateTypes(state.selectedWms).then(() => {
              //   arrRefs[SELECT_TEMPLATE_TYPE].current.setValue(NEW_FILE)
              // })
              arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
              arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
              arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(true)
              arrRefs[SELECT_ACOUNT_LEVEL2].current.clearErrorMsg()
              arrRefs[SELECT_ACOUNT_LEVEL3].current.clear()
              arrRefs[SELECT_ORDER_NUMBER].current.focus()
            }
            clearBusy()
          }
        })
    } else {
      arrRefs[SELECT_ACOUNT_LEVEL2].current.setErrorMsg('Account Level 1/ Customer Required', true)
      clearBusy()
    }
  }

  const validateAccountLevel3 = (value) => {
    if (arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue() !== '') {
      // Remove below if condition after ONEIL requirement finalized
      // if (state.WMSSystem === SKP_SYSTEM) {
      setBusy()
      validateAndGetAccountLevel3(getState()?.wmsInstance, arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue(), arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue(), value)
        .then(async (result) => {
          const errors = getState().validationErrors
          if (result.error) {
            // arrRefs[SELECT_ACOUNT_LEVEL3].current.setErrorMsg(result.error, true)
            errors[SELECT_ACOUNT_LEVEL3] = result.error
            setState({ validationErrors: errors, errorMsg: result.error })
          } else if (result.success && result.statusCode === 200) {
            delete errors[SELECT_ACOUNT_LEVEL3]
            setState({ validationErrors: errors, showForm: true, errorMsg: '', resetBtn: true })
            arrRefs[SELECT_ACOUNT_LEVEL3].current.clearErrorMsg()
            arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(true)
            arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(true)
            arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(true)
            arrRefs[SELECT_ORDER_NUMBER].current.focus()
          }
          clearBusy()
        })
    } else {
      clearBusy()
      arrRefs[SELECT_ACOUNT_LEVEL3].current.setErrorMsg('Account Level 1/ Customer is Required', true)
    }
  }

  // const onChangeDepartment = (e) => {
  //   const value = e?.target?.value
  //   if (e.keyCode === 13) {
  //     if (value) {
  //       validateAccountLevel3(value)
  //     } else {
  //       arrRefs[SELECT_TEMPLATE_TYPE].current?.focus()
  //     }
  //   }
  // }

  // const onBlurDepartment = (e) => {
  //   e?.preventDefault()
  //   validateAccountLevel3(e?.target?.value)
  // }


  // const onChangeWms = (value) => {
  //   setBusy()
  //   if (value !== undefined && value !== constants.defaultSelect) {
  //     setState({ selectedWms: value, selectedTemplate: '', WMSSystem: value })
  //     // getTemplateTypes(value.toLowerCase()).then(() => {
  //     //   arrRefs[SELECT_TEMPLATE_TYPE].current.setValue(NEW_FILE)
  //     // })
  //     if (value === ONEIL_SYSTEM) {
  //       setShowOrderCount(true)
  //     } else {
  //       setShowOrderCount(false)
  //     }
  //   } else {
  //     getTemplateTypes('')
  //     arrRefs[SELECT_TEMPLATE_NAME].current.clear()
  //   }
  //   arrRefs[SELECT_ACOUNT_LEVEL1].current.clear()
  //   arrRefs[SELECT_ACOUNT_LEVEL2].current.clear()
  //   arrRefs[SELECT_ACOUNT_LEVEL3].current.clear()
  //   arrRefs[SELECT_TEMPLATE_TYPE].current.clear()
  //   if (arrRefs[SKP_INSTANCE].current != null) {
  //     arrRefs[SKP_INSTANCE].current.clear()
  //   }
  //   clearBusy()
  // }

  const onChangeTemplate = (value) => {
    if (value === undefined || value === constants.defaultSelect || value === null) {
      setState({ showTable: false, chargeDisabled: true })
    } else {
      if (getState().templateTypeState === 'New Box' || getState().templateTypeState === 'New File') {
        setState({ isTemplateChanged: true, isCustomFieldsNotAdded: true })
        if (value === useStandardTemplate) {
          title = getState().standardTemplates[arrRefs[SELECT_TEMPLATE_TYPE].current.getValue()].templateName
        } else {
          setState({ enableAddFieldsBtn: true })
          title = value
        }
        setState({ showTable: true, selectedTemplate: value })
      } else {
        const maintenanceCodecharge = getState().templates[value]?.data()?.templateFields?.maintenanceCode?.defaultValue
        if (value === useStandardTemplate) {
          title = getState().standardTemplates[arrRefs[SELECT_TEMPLATE_TYPE].current.getValue()].templateName
          setState({ chargeDisabled: false })
          const fields = getState().standardTemplates[arrRefs[SELECT_TEMPLATE_TYPE].current.getValue()].templateFields
          setIsChecked(false)
          fields.maintenanceCode.defaultValue = 'N'
        } else {
          title = value
          setState({ enableAddFieldsBtn: true, chargeDisabled: false, showTable: true, selectedTemplate: value })
          if (maintenanceCodecharge !== undefined) {
            setIsChecked(maintenanceCodecharge === 'C')
          } else {
            setState({ chargeDisabled: true })
          }     
        }
        setState({ showTable: true, selectedTemplate: value })
      }
    }
  }

  const onChangeTemplateType = (value) => {
    templateTypeSelected = value
    if (value !== undefined || value !== undefined || value !== constants.defaultSelect) {
      setState({ templateTypeState: value })
      getTemplatesForTemplateType(value, getState().selectedWms)
    }
    arrRefs[SELECT_TEMPLATE_NAME].current.setValue(constants.defaultSelect)

    if (value !== undefined && value !== '--Select--') {
      let hideTransmitCheckbox = true
      let transmitCheckboxTicked = false
      let disableTransmitCheckbox = false
      const arrayOfAllowedUsersToChangeManualTransmit = [userRoleAdmin, userRoleSupervisor, userRoleSuperUser]
      if (getState().templateTypeState !== 'Maintenance Box' && getState().templateTypeState !== 'New Box') {
        hideTransmitCheckbox = false
        disableTransmitCheckbox = false
        transmitCheckboxTicked = false
      } 
      
      if (getState().workerDetails.countryCode === 'gb') {
        hideTransmitCheckbox = false
        disableTransmitCheckbox = true
        transmitCheckboxTicked = true
        if (arrayOfAllowedUsersToChangeManualTransmit.includes(getState()?.workerDetailsGde?.gdeRole.toUpperCase())) {
          disableTransmitCheckbox = false
        }
      }
      setState({ hideManualTransmitCheckbox: hideTransmitCheckbox })
      setIsAutoTransmitForCopyJob(transmitCheckboxTicked)
      arrRefs[CHECK_FIELD]?.current?.setValue(transmitCheckboxTicked)
      setTimeout(setState({ disableManualTransmitCheckbox: disableTransmitCheckbox }), 10000)
    }
  }

  const saveTemplateValues = (values) => {
    const selectedTemplateValues = JSON.stringify(values)
    setState({ selectedTemplateValues: selectedTemplateValues })
  }

  const onSelectionFromDate = (value) => {
    const targetDateValue = arrRefs[DATE_TARGET].current.getValue()
    const target = new Date(targetDateValue).getTime()
    const pickup = new Date(value).getTime()
    const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000

    if (pickup > target) {
      return 'messages.pickupDateValidation'
    }

    if (target - pickup < thirtyDaysInMs) {
      return 'messages.lessThan30Days'
    }

    return ''
  }

  const onSelectionToDate = (value) => {
    const pickupDate = arrRefs[DATE_PICKUP].current.getValue()
    const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000
    const pickup = new Date(pickupDate).getTime()
    const target = new Date(value).getTime()

    if (target < pickup) {
      return 'messages.targetDateValidation'
    }

    if (target - pickup < thirtyDaysInMs) {
      return 'messages.lessThan30Days'
    }

    const todayDate = new Date()
    const today = new Date(todayDate).getTime()

    if (target < today) {
      return 'messages.targetDateSelectedOldDate'
    }

    return ''
  }

  // const handleEOnInput = (evt) => {
  //   if (evt.key === 'e' || evt.key === 'E' || evt.key === '-') {
  //     evt.preventDefault()
  //     /* eslint no-useless-return: */
  //     return
  //   }
  // }

  const openAddCustomFieldsDialog = () => {
    saveStandardTemplateValues()
    saveTemplateFieldNames()
    setOpen(true)
    setState({ openCustomFieldsDialog: true, showTable: false })
  }

  //  saves selected standard template type fields
  const saveStandardTemplateValues = () => {
    const fields =
      getState().standardTemplates[
        arrRefs[SELECT_TEMPLATE_TYPE].current.getValue()
      ].templateFields
    const arrayFields = Object.keys(fields).map((key) => {
      const data = fields[key]
      data.name = key
      return data
    })
    arrayFields.sort((a, b) =>
      a.customOrder > b.customOrder ? 1 : b.customOrder > a.customOrder ? -1 : 0
    )
    setState({ saveStandardTempValues: arrayFields })
  }

  //  saves all the checked fields
  const handleSaveCustomFields = () => {
    let savedFields = []
    savedFields = selectedFields.concat(getState().selectedCustomTemplateFields)
    setState({
      addedCustomFields: savedFields,
      showTable: true,
      renderNewTemplate: true,
      isCustomFieldsNotAdded: false,
      isTemplateChanged: false
    })
    getTemplateFields()
    setState({ openCustomFieldsDialog: false, enableAddFieldsBtn: false })
  }

  const closeAddCustomFieldsDialog = () => {
    setState({ showTable: true })
    setState({ openCustomFieldsDialog: false })
  }
  let selectedFields = []

  //  saves and deletes fields from dialog as user checks and unchecks fields from dialog
  const handleCheckBox = (e, field) => {
    e && selectedFields.push(field)
    if (e === false) {
      selectedFields = reject(selectedFields, (f) => f.name === field.name)
    }
  }
  const closeResetFields = () => {
    setState({ showTable: true })
    closeGeneralDialog()
  }
  const ButtonsForResetFields = () => {
    return (
      <>
        <OutlinedButton onClick={closeResetFields}>buttons.no</OutlinedButton>
        <ContainedButton onClick={confirmResetFields}>
          buttons.yes
        </ContainedButton>
      </>
    )
  }

  const confirmResetFields = () => {
    setState({ renderNewTemplate: false, isCustomFieldsNotAdded: true, isTemplateChanged: false })
    getTemplateFields()
    setState({ showTable: true, enableAddFieldsBtn: true })
    closeGeneralDialog()
  }

  //  resets to selected custom templateFields
  const resetFields = () => {
    setState({ showTable: false })
    openGeneralDialog({
      title: t('options.resetField'),
      message: t('options.resetFields'),
      noTranslate: true,
      noTranslateTitle: true,
      buttons: <ButtonsForResetFields />,
      closeX: false
    })
  }
  //  saves custom templateFields
  const saveTemplateFieldNames = () => {
    const selectedCustomTemplateFieldNames = []
    getState().selectedCustomTemplateFields.map((field) => {
      return selectedCustomTemplateFieldNames.push(field.name)
    })
    setState({
      selectedCustomTemplateFieldNames: selectedCustomTemplateFieldNames
    })
  }

  const handleValidate = () => {
    if (arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue() !== '' && arrRefs[SELECT_ACOUNT_LEVEL3].current.getValue() !== '') {
      validateAccountLevel3(arrRefs[SELECT_ACOUNT_LEVEL3].current.getValue())
    } else if (arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue() !== '' && arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue() !== '' && arrRefs[SELECT_ACOUNT_LEVEL3].current.getValue() === '') {
      validateAccountLevel2(arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue())
    } else if (arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue() !== '' && arrRefs[SELECT_ACOUNT_LEVEL2].current.getValue() === '' && arrRefs[SELECT_ACOUNT_LEVEL3].current.getValue() === '') {
      validateAccountLevel1(arrRefs[SELECT_ACOUNT_LEVEL1].current.getValue())
    }
  }

  const handleReset = () => {
    setState({ showForm: false, showTable: false, resetBtn: false })
    arrRefs[SELECT_ACOUNT_LEVEL1].current.clear()
    arrRefs[SELECT_ACOUNT_LEVEL2].current.clear()
    arrRefs[SELECT_ACOUNT_LEVEL3].current.clear()
    arrRefs[SELECT_ACOUNT_LEVEL1].current.setDisabled(false)
    arrRefs[SELECT_ACOUNT_LEVEL2].current.setDisabled(false)
    arrRefs[SELECT_ACOUNT_LEVEL3].current.setDisabled(false)
    arrRefs[SELECT_ACOUNT_LEVEL1].current.focus()
  }


  return (
    <>
      <MainRouteSubRoutePage
        mainTitle='routeTitles.jobManagement'
        subTitle='routeTitles.createNewJob'
        createJobParams={[getState()?.countryCode, getState()?.districtId, getState()?.wmsInstance, getState()?.country]}
        buttons={getState()?.showForm && <PageButtons arrRefs={arrRefs} handleSaveAndAssignJob={handleSaveAndAssignJob} handleCancel={handleCancel} showTable={getState()?.showTable} handleSaveJobForLater={handleSaveJobForLater} handleSaveAndAssignJobWithoutTemplate={handleSaveAndAssignJobWithoutTemplate} validationErrors={getState().validationErrors} />} createPage={true}
      >
        <Card style={{ width: '70vw', margin: '1rem' }}>
          <CardContent>
            <CreateTemplateAccountsIntentContainer>
              <TextField
                id={'createJob_accountLevel'}
                // onKeyDown={(e) => onChangeCustomer(e)}
                // onBlur={(e) => onBlurCustomer(e)}
                data={data}
                fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL1]}
                ref={arrRefs[SELECT_ACOUNT_LEVEL1]}
              />
              <TextField
                id={'createJob_accountLeve2'}
                // onKeyDown={(e) => onChangeDivision(e)}
                // onBlur={(e) => onBlurDivision(e)}
                data={data}
                fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL2]}
                ref={arrRefs[SELECT_ACOUNT_LEVEL2]}
              />
              <TextField
                id={'createJob_department'}
                // onKeyDown={(e) => onChangeDepartment(e)}
                // onBlur={(e) => onBlurDepartment(e)}
                data={data}
                fieldTemplate={formTemplate[SELECT_ACOUNT_LEVEL3]}
                ref={arrRefs[SELECT_ACOUNT_LEVEL3]}
              />
              {getState()?.resetBtn
                ? <OutlinedButton onClick={() => handleReset()} style={{ width: '100px', height: '36.5px' }}>buttons.Reset</OutlinedButton>
                : <ContainedButton onClick={() => handleValidate()} style={{
                  width: '100px',
                  height: '36.5px'
                }}>buttons.validate</ContainedButton>}
            </CreateTemplateAccountsIntentContainer>
            <Typography paragraph={true} style={{ fontSize: '16px', color: '#FFF', backgroundColor: '#db4437', width: 'fit-content' }}>{getState()?.errorMsg}</Typography>
          </CardContent>
        </Card>
        <Box component='div' style={{ backgroundColor: '#F3F3F3', width: '100%', height: '1rem', margin: 0, padding: 0 }} />
        {getState()?.showForm && <Card style={{ width: '70vw', margin: '0.5rem' }}>
          <CardContent>
            <CreateJobIntentContainer>
              <TextField id={'createJob_orderNumber'} data={data} fieldTemplate={formTemplate[SELECT_ORDER_NUMBER]} ref={arrRefs[SELECT_ORDER_NUMBER]} />
              <Autocomplete
                // In place of Select we've added Autocomplete to search for the names
                id={'createJob_templateType'}
                data={data}
                options={state.templateTypeList}
                fieldTemplate={formTemplate[SELECT_TEMPLATE_TYPE]}
                ref={arrRefs[SELECT_TEMPLATE_TYPE]}
                onChange={onChangeTemplateType}
                noTranslateItems
              />
              <Autocomplete
                id={'createJob_templateName'}
                data={data}
                options={state.templatesForSelect}
                fieldTemplate={formTemplate[SELECT_TEMPLATE_NAME]}
                ref={arrRefs[SELECT_TEMPLATE_NAME]}
                onChange={onChangeTemplate}
                noTranslateItems
              />
            </CreateJobIntentContainer>
            <CreateJobDatesIntentContainer>
              <DateTime
                id={'createJob_pickupDateFrom'}
                data={data}
                fieldTemplate={formTemplate[DATE_PICKUP]}
                ref={arrRefs[DATE_PICKUP]}
                type='date'
              />
              <DateTime
                id={'createJob_pickupDateTo'}
                data={data}
                fieldTemplate={formTemplate[DATE_TARGET]}
                ref={arrRefs[DATE_TARGET]}
                type='date'
                minDate={afterThirtyDaysFromToday()}
              />
            </CreateJobDatesIntentContainer>
            <CreateJobCheckBoxIntentContainer>
              {!getState()?.hideManualTransmitCheckbox &&
                <>
                  <div>
                    <CheckBox
                      id={'createJob_manualTransmit'}
                      data={data}
                      fieldTemplate={formTemplate[CHECK_FIELD]}
                      ref={arrRefs[CHECK_FIELD]}
                      checked={isAutoTransmitForCopyJob}
                      disabled={getState()?.disableManualTransmitCheckbox}
                    />

                    <ToolTip
                      message='messages.manualTransmitMessage'
                      style={{ height: '21px' }}
                    ><Info />
                    </ToolTip>
                  </div>
                </>}
              {templateTypeSelected === 'Maintenance Box' || templateTypeSelected === 'Maintenance File'
                ? <>
                  <CheckBox
                    id={'createJob_chargeForMaintenance'}
                    data={data}
                    fieldTemplate={formTemplate[CHECK_CHARGE]}
                    checked={isChecked}
                    onChange={handleOnChange}
                    disabled={state.chargeDisabled}
                  />
                </>
                : null
              }
              <>
                <div>
                  <CheckBox
                    id={'createJob_qualityCheck'}
                    data={data}
                    checked={getState().isQualityCheck}
                    onChange={handleOnQcChange}
                    fieldTemplate={formTemplate[QUALITY_CHECK]}
                    ref={arrRefs[QUALITY_CHECK]}
                  />
                  <ToolTip
                    message='messages.qualityCheckMessage'
                    style={{ height: '21px' }}
                  ><Info />
                  </ToolTip>
                  <XDivider width='40px' />
                </div>
              </>
              {getState().templateTypeState === 'New File' &&
                <>
                  <div>
                    <CheckBox
                      id={'createJob_uploadCustomerDataFile'}
                      data={data}
                      fieldTemplate={formTemplate[UPLOAD_CUSTOMER_DATA_FILE]}
                      ref={arrRefs[UPLOAD_CUSTOMER_DATA_FILE]}
                    />
                    <ToolTip
                      message='messages.uploadCustomerDataFile'
                      style={{ height: '21px' }}
                    ><Info />
                    </ToolTip>
                  </div>
                </>}
            </CreateJobCheckBoxIntentContainer>
            {/* <CreateJobCheckBoxIntentContainer> */}
            <>
              <div>
                <CheckBox
                  id={'createJob_barcodeLogic'}
                  data={data}
                  fieldTemplate={formTemplate[BARCODE_LOGIC]}
                  ref={arrRefs[BARCODE_LOGIC]}
                />
                <ToolTip
                  message='messages.barcodeLogic'
                  style={{ height: '21px' }}
                ><Info />
                </ToolTip>
              </div>
            </>
            {/* </CreateJobCheckBoxIntentContainer> */}
            <OutlinedButton style={{ width: '25vw' }} onClick={handleAddInst}>buttons.addInstructions</OutlinedButton>
          </CardContent>
        </Card>
        }
        {getState().showTable
          ? (
            <Box component='div' style={{ margin: '0.5rem' }}>
              <VerticalDivider />
              <TemplateFormat
                tableRef={tableRef}
                getPageData={getTemplateFields}
                title={title}
                setSelectedTemplateValues={saveTemplateValues}
                formTemplates={formTemplate}
                arrRefs={arrRefs}
                skpEncoding={getState()?.skpEncoding}
                isEdit={false}
                getState={getState}
              />
              {getState().selectedTemplate !== useStandardTemplate &&
                getState().enableAddFieldsBtn && (
                  <ContainedButton disabled={isDataEntryUser()}
                    onClick={openAddCustomFieldsDialog}
                    style={{ float: 'right' }}
                  >
                    buttons.addFields
                  </ContainedButton>
              )}
              {!getState().isCustomFieldsNotAdded && (
                <>
                  <OutlinedButton
                    onClick={resetFields}
                    style={{ float: 'right' }}
                  >
                    buttons.resetFields
                  </OutlinedButton>
                </>
              )}
            </Box>
            )
          : null}
        {getState().openCustomFieldsDialog && (
          <Dialog open={open} onClose={handleClose}>
            <DialogTitle>{t('buttons.addFields')}</DialogTitle>
            <DialogContent style={{ width: '300px', height: 'auto' }}>
              <Grid container spacing={10}>
                <Grid item xs={5}>
                  {getState().saveStandardTempValues.map((field) => {
                    return (
                      field.isSelected &&
                      !getState().selectedCustomTemplateFieldNames.includes(
                        field.name
                      ) && (
                        <>
                          <CheckBox
                            label={field.name}
                            noTranslate
                            onChange={(e) => handleCheckBox(e, field)}
                          />
                        </>
                      )
                    )
                  })}
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <OutlinedButton onClick={closeAddCustomFieldsDialog}>
                buttons.cancel
              </OutlinedButton>
              <ContainedButton onClick={handleSaveCustomFields}>
                buttons.save
              </ContainedButton>
            </DialogActions>
          </Dialog>
        )}

      </MainRouteSubRoutePage>
    </>
  )
}

export default CreateJob